import { colors } from "./colors";

export const body = {
    fontFamily: "montserrat",
    fontSize: "14px",
    fontWeight: "400",
    color: colors.black
}

export const body1 = {
    fontFamily: "montserrat",
    fontSize: "12px",
    fontWeight: "400",
    color: colors.darkGray
}

export const tooltipContent = {
    fontFamily: 'montserrat',
    fontSize: "14px",
    fontWeight: '300',
    color: colors.white
}

export const title1 = {
    fontFamily: "montserrat",
    fontSize: "40px",
    fontWeight: "600",
    color: colors.black
};

export const title2 = {
    fontFamily: "montserrat",
    fontSize: "30px",
    fontWeight: "600",
    color: colors.black
};

export const subTitle1 = {
    fontFamily: "montserrat",
    fontSize: "20px",
    fontWeight: "500",
    color: colors.redSubtitle
};

export const subTitle2 = {
    fontFamily: "montserrat",
    fontSize: "14px",
    fontWeight: "500",
    color: colors.redSubtitle
};

export const subTitle3 = {
    fontFamily: "montserrat",
    fontSize: "14px",
    fontWeight: "400",
    color: colors.black
};

export const subTitle3Bold = {
    fontFamily: "montserrat",
    fontSize: "14px",
    fontWeight: "700",
    color: colors.black
};

export const subTitle4 = {
    fontFamily: "montserrat",
    fontSize: "11px",
    fontWeight: "400",
    color: colors.redSubtitle
};

export const subTitle5 = {
    fontFamily: "montserrat",
    fontSize: "9px",
    fontWeight: "400",
    color: colors.black
};

export const subTitle6 = {
    fontFamily: "montserrat",
    fontSize: "14px",
    fontWeight: "400",
    color: colors.redSubtitle
};

export const subTitle7 = {
    fontFamily: "montserrat",
    fontSize: "10px",
    fontWeight: "400",
    color: colors.black
};

export const subTitle7Bold = {
    fontFamily: "montserrat",
    fontSize: "10px",
    fontWeight: "700",
    color: colors.black
};

export const text15W600Black = {
  fontFamily: "montserrat",
  fontSize: "15px",
  fontWeight: "600",
  color: colors.black
};

export const text15W300Black = {
  fontFamily: "montserrat",
  fontSize: "15px",
  fontWeight: "300",
  color: colors.black
};

